import { render, staticRenderFns } from "./PlayerOfferOld.vue?vue&type=template&id=b7fbaf02&"
import script from "./PlayerOfferOld.vue?vue&type=script&lang=js&"
export * from "./PlayerOfferOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports